import { render } from "./CCheckBox.vue?vue&type=template&id=3b2f59a3"
import script from "./CCheckBox.vue?vue&type=script&lang=js"
export * from "./CCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__